import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const navigate = useNavigate();

  const menuItems = [
    { label: "Home", path: "/" },
    { label: "About Us", path: "/about" },
    { label: "Products", path: "/products" },
    { label: "Projects", path: "/projects" },
    { label: "News", path: "/news" },
    { label: "Maintenance", path: "/maintenance" },
    { label: "Contact Us", path: "/contact" },
  ];

  return (
    <nav className="bg-white shadow-md px-6 flex items-center justify-between sticky top-0 z-50">
      
      {/* Logo */}
      <div className="flex items-center cursor-pointer" onClick={() => navigate("/")}>
        <img
          src="/Images/zajra_logo.png"
          alt="ZajraGreen Logo"
          className="w-24 h-20 object-contain"
        />
      </div>

      {/* Hamburger for Mobile */}
      <button
        className="md:hidden text-gray-700 focus:outline-none z-50"
        onClick={() => setIsOpen(!isOpen)}
      >
        <svg className="w-10 h-10" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          {isOpen ? (
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
          ) : (
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6h16M4 12h16M4 18h16" />
          )}
        </svg>
      </button>

      {/* Desktop Menu */}
      <ul className="hidden md:flex gap-8 font-medium text-black items-center">
        {menuItems.map((item, index) => (
          <li
            key={index}
            className="hover:text-green-600 cursor-pointer transition-colors"
            onClick={() => navigate(item.path)}
          >
            {item.label}
          </li>
        ))}
      </ul>

      {/* Mobile Sidebar + Overlay */}
      <div className="md:hidden">
        {/* Overlay */}
        <div
          className={`fixed inset-0 bg-black bg-opacity-25 transition-opacity duration-300 ${
            isOpen ? "opacity-100" : "opacity-0 pointer-events-none"
          }`}
          onClick={() => setIsOpen(false)}
        ></div>

        {/* Sidebar */}
        <div
          className={`fixed top-0 left-0 h-full w-64 bg-white shadow-lg transform transition-transform duration-300 z-50 ${
            isOpen ? "translate-x-0" : "-translate-x-full"
          }`}
        >
          <ul className="flex flex-col mt-24 ml-6 gap-6 text-gray-700 font-medium">
            {menuItems.map((item, index) => (
              <li
                key={index}
                className="hover:text-green-600 cursor-pointer transition-colors"
                onClick={() => {
                  navigate(item.path);
                  setIsOpen(false);
                }}
              >
                {item.label}
              </li>
            ))}
          </ul>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
